/* MagSert add-on — add a companion product to the cart from a product page,
   reusing the theme's own cart drawer (Dawn's cart-drawer / cart-notification
   renderContents). No vendor files are modified. */
(function () {
  'use strict';

  // A page can carry more than one add-on (the buy-box row AND the full card
  // lower down), and each emits its own <script src> tag. Same URL, but the
  // browser still executes the file once per tag — without this guard every
  // button would end up with two click handlers and add 2 to the cart.
  if (window.__magsertAddonBooted) return;
  window.__magsertAddonBooted = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function init(el) {
    if (el.dataset.magsertAddonReady) return;
    el.dataset.magsertAddonReady = '1';

    var btn = el.querySelector('.addon__btn');
    var msg = el.querySelector('.addon__msg');
    var variantId = el.getAttribute('data-variant-id');
    var addedLabel = el.getAttribute('data-added-label') || 'Added to cart';
    if (!btn || !variantId) return;

    var idle = btn.textContent;

    function say(text, isError) {
      if (!msg) return;
      msg.hidden = false;
      msg.textContent = text;
      msg.classList.toggle('addon__msg--error', !!isError);
    }

    btn.addEventListener('click', function () {
      btn.disabled = true;
      btn.textContent = 'Adding…';

      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var body = { items: [{ id: Number(variantId), quantity: 1 }] };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.status) {
            // Shopify error payload (e.g. sold out while on page)
            say(data.description || data.message || 'Sorry, this could not be added.', true);
            btn.textContent = idle;
            btn.disabled = false;
            return;
          }
          btn.textContent = addedLabel;
          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(data);
          } else {
            say('Added. View your cart to check out.');
          }
          setTimeout(function () { btn.textContent = idle; btn.disabled = false; }, 2500);
        })
        .catch(function () {
          say('Something went wrong. Please try again.', true);
          btn.textContent = idle;
          btn.disabled = false;
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-magsert-addon]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
